var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"divider",class:{'divider_not-show-last-child': _vm.notShowLastChild},style:({margin: _vm.dividerMarginValue})})}
var staticRenderFns = []

export { render, staticRenderFns }